/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseFontSizeEnum } from './DatabaseFontSizeEnum';
import {
    DatabaseFontSizeEnumFromJSON,
    DatabaseFontSizeEnumFromJSONTyped,
    DatabaseFontSizeEnumToJSON,
} from './DatabaseFontSizeEnum';
import type { DatabaseHeaderBlockActionType } from './DatabaseHeaderBlockActionType';
import {
    DatabaseHeaderBlockActionTypeFromJSON,
    DatabaseHeaderBlockActionTypeFromJSONTyped,
    DatabaseHeaderBlockActionTypeToJSON,
} from './DatabaseHeaderBlockActionType';
import type { DatabaseTextHeaderBlock } from './DatabaseTextHeaderBlock';
import {
    DatabaseTextHeaderBlockFromJSON,
    DatabaseTextHeaderBlockFromJSONTyped,
    DatabaseTextHeaderBlockToJSON,
} from './DatabaseTextHeaderBlock';

/**
 * Klappmenue mit allen Datenbanken der Familie (Haupt- und Unterdatenbanken). Erbt vom Textblock, weil zweierlei gebraucht wird: `content` traegt die Einstellungen als JSON (Beschriftung, Ansicht) — dasselbe Verfahren wie beim Kleingedruckten —, und die Schriftfelder gestalten die Beschriftung des Menues.
 * Ein eigener Eintrag ist an MEHREREN Stellen noetig: hier, in der oneOf-Liste von contentBlocks und in BEIDEN discriminator-Zuordnungen. Fehlt einer, faellt der Typ auf die Basis zurueck — `content` geht beim Speichern verloren und die Einstellungen sind nach dem naechsten Laden weg, ohne dass irgendwo ein Fehler erschiene.
 * @export
 * @interface DatabaseDbMenuHeaderBlock
 */
export interface DatabaseDbMenuHeaderBlock extends DatabaseTextHeaderBlock {
}

/**
 * Check if a given object implements the DatabaseDbMenuHeaderBlock interface.
 */
export function instanceOfDatabaseDbMenuHeaderBlock(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseDbMenuHeaderBlockFromJSON(json: any): DatabaseDbMenuHeaderBlock {
    return DatabaseDbMenuHeaderBlockFromJSONTyped(json, false);
}

export function DatabaseDbMenuHeaderBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseDbMenuHeaderBlock {
    return json;
}

export function DatabaseDbMenuHeaderBlockToJSON(value?: DatabaseDbMenuHeaderBlock | null): any {
    return value;
}

